"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoBoneEpochResponseT = exports.AutoBoneEpochResponse = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const skeleton_part_js_1 = require("../../solarxr-protocol/rpc/skeleton-part.js");
class AutoBoneEpochResponse {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsAutoBoneEpochResponse(bb, obj) {
        return (obj || new AutoBoneEpochResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsAutoBoneEpochResponse(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new AutoBoneEpochResponse()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    currentEpoch() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    totalEpochs() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    /**
     * The current error value. This can be any positive number, where lower is better.
     */
    epochError() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readFloat32(this.bb_pos + offset) : 0.0;
    }
    /**
     * A list of the current estimated body proportions.
     */
    adjustedSkeletonParts(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? (obj || new skeleton_part_js_1.SkeletonPart()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    adjustedSkeletonPartsLength() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startAutoBoneEpochResponse(builder) {
        builder.startObject(4);
    }
    static addCurrentEpoch(builder, currentEpoch) {
        builder.addFieldInt32(0, currentEpoch, 0);
    }
    static addTotalEpochs(builder, totalEpochs) {
        builder.addFieldInt32(1, totalEpochs, 0);
    }
    static addEpochError(builder, epochError) {
        builder.addFieldFloat32(2, epochError, 0.0);
    }
    static addAdjustedSkeletonParts(builder, adjustedSkeletonPartsOffset) {
        builder.addFieldOffset(3, adjustedSkeletonPartsOffset, 0);
    }
    static createAdjustedSkeletonPartsVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startAdjustedSkeletonPartsVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endAutoBoneEpochResponse(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createAutoBoneEpochResponse(builder, currentEpoch, totalEpochs, epochError, adjustedSkeletonPartsOffset) {
        AutoBoneEpochResponse.startAutoBoneEpochResponse(builder);
        AutoBoneEpochResponse.addCurrentEpoch(builder, currentEpoch);
        AutoBoneEpochResponse.addTotalEpochs(builder, totalEpochs);
        AutoBoneEpochResponse.addEpochError(builder, epochError);
        AutoBoneEpochResponse.addAdjustedSkeletonParts(builder, adjustedSkeletonPartsOffset);
        return AutoBoneEpochResponse.endAutoBoneEpochResponse(builder);
    }
    unpack() {
        return new AutoBoneEpochResponseT(this.currentEpoch(), this.totalEpochs(), this.epochError(), this.bb.createObjList(this.adjustedSkeletonParts.bind(this), this.adjustedSkeletonPartsLength()));
    }
    unpackTo(_o) {
        _o.currentEpoch = this.currentEpoch();
        _o.totalEpochs = this.totalEpochs();
        _o.epochError = this.epochError();
        _o.adjustedSkeletonParts = this.bb.createObjList(this.adjustedSkeletonParts.bind(this), this.adjustedSkeletonPartsLength());
    }
}
exports.AutoBoneEpochResponse = AutoBoneEpochResponse;
class AutoBoneEpochResponseT {
    constructor(currentEpoch = 0, totalEpochs = 0, epochError = 0.0, adjustedSkeletonParts = []) {
        this.currentEpoch = currentEpoch;
        this.totalEpochs = totalEpochs;
        this.epochError = epochError;
        this.adjustedSkeletonParts = adjustedSkeletonParts;
    }
    pack(builder) {
        const adjustedSkeletonParts = AutoBoneEpochResponse.createAdjustedSkeletonPartsVector(builder, builder.createObjectOffsetList(this.adjustedSkeletonParts));
        return AutoBoneEpochResponse.createAutoBoneEpochResponse(builder, this.currentEpoch, this.totalEpochs, this.epochError, adjustedSkeletonParts);
    }
}
exports.AutoBoneEpochResponseT = AutoBoneEpochResponseT;
